// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roq-chat-window__content__file-upload {
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
  height: auto;
  inset: 0;
  padding-bottom: var(--spacing-medium);
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  position: absolute;
  width: auto;
  z-index: var(--z-modals);
}

.roq-chat-message-file-upload__close {
  cursor: pointer;
  padding: var(--spacing-small);
}

.roq-chat-message-file-upload__content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: var(--spacing-small);
}

.roq-chat-message-file-upload__content__preview {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.roq-chat-message-file-upload__content__preview__image {
  inset: 0;
  margin: 0 auto;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
}

.roq-chat-message-file-upload__content__file-list {
  display: flex;
  gap: var(--spacing-small);
  height: var(--spacing-huge);
  justify-content: center;
}

.roq-chat-message-file-upload-list__item {
  border: 1px solid transparent;
  border-radius: var(--border-radius-tiny);
  cursor: pointer;
  height: var(--size-file-preview-thumb-height);
  width: var(--size-file-preview-thumb-width);
}

.roq-chat-message-file-upload-list__item--selected {
  border-color: var(--color-outline);
}

.roq-chat-message-file-upload-list__item__preview {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.roq-chat-message-file-upload-list__add-button {
  border: var(--border-dark);
  height: var(--size-file-preview-thumb-height);
  width: var(--size-file-preview-thumb-width);
}

.roq-chat-message-file-upload-preview__file-icon {
  color: var(--color-icons-inactive);
  max-width: var(--size-file-preview-width);
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_window-file-preview.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,eAAe;EACf,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C","sourcesContent":[".roq-chat-window__content__file-upload {\n  background-color: var(--color-background);\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  inset: 0;\n  padding-bottom: var(--spacing-medium);\n  padding-left: var(--spacing-medium);\n  padding-right: var(--spacing-medium);\n  position: absolute;\n  width: auto;\n  z-index: var(--z-modals);\n}\n\n.roq-chat-message-file-upload__close {\n  cursor: pointer;\n  padding: var(--spacing-small);\n}\n\n.roq-chat-message-file-upload__content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: var(--spacing-small);\n}\n\n.roq-chat-message-file-upload__content__preview {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.roq-chat-message-file-upload__content__preview__image {\n  inset: 0;\n  margin: 0 auto;\n  max-height: 100%;\n  max-width: 100%;\n  position: absolute;\n}\n\n.roq-chat-message-file-upload__content__file-list {\n  display: flex;\n  gap: var(--spacing-small);\n  height: var(--spacing-huge);\n  justify-content: center;\n}\n\n.roq-chat-message-file-upload-list__item {\n  border: 1px solid transparent;\n  border-radius: var(--border-radius-tiny);\n  cursor: pointer;\n  height: var(--size-file-preview-thumb-height);\n  width: var(--size-file-preview-thumb-width);\n}\n\n.roq-chat-message-file-upload-list__item--selected {\n  border-color: var(--color-outline);\n}\n\n.roq-chat-message-file-upload-list__item__preview {\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.roq-chat-message-file-upload-list__add-button {\n  border: var(--border-dark);\n  height: var(--size-file-preview-thumb-height);\n  width: var(--size-file-preview-thumb-width);\n}\n\n.roq-chat-message-file-upload-preview__file-icon {\n  color: var(--color-icons-inactive);\n  max-width: var(--size-file-preview-width);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
